import React from 'react';
import { TailSpin } from './TailSpin';
import { Grid } from './Grid';
import { ThreeDots } from './ThreeDots';
export const Loader = ({ className, height = 24, width = 24, color = '#588CB0', type = 'TailSpin', }) => {
    switch (type) {
        case 'Grid': {
            return React.createElement(Grid, { className: className, height: height, width: width, color: color });
        }
        case 'ThreeDots': {
            return React.createElement(ThreeDots, { className: className, height: height, width: width, color: color });
        }
        case 'TailSpin':
        default: {
            return React.createElement(TailSpin, { className: className, height: height, width: width, color: color });
        }
    }
};
//# sourceMappingURL=Loader.js.map